"use client";

import { motion, useReducedMotion } from "framer-motion";

interface AnimatedSectionProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  direction?: "up" | "left" | "right" | "none";
}

// Reusable scroll-entrance wrapper so section markup stays server-rendered;
// children are passed through from server components.
export default function AnimatedSection({
  children,
  className,
  delay = 0,
  direction = "up",
}: AnimatedSectionProps) {
  const reduceMotion = useReducedMotion();

  const offset = reduceMotion
    ? {}
    : direction === "up"
    ? { y: 24 }
    : direction === "left"
    ? { x: -24 }
    : direction === "right"
    ? { x: 24 }
    : {};

  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, ...offset }}
      whileInView={{ opacity: 1, x: 0, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{
        duration: reduceMotion ? 0 : 0.5,
        ease: "easeOut",
        delay: reduceMotion ? 0 : delay,
      }}
    >
      {children}
    </motion.div>
  );
}
